module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/error.65d70633.svg";